export const themes = {
    light: {
        background: 'bg-white',
        text: 'text-gray-900',
        secondaryText: 'text-gray-600',
        headerBg: 'bg-gray-100',
        headerText: 'text-gray-800',
        dayBg: 'bg-slate-100',
        dayHeaderBg: 'bg-slate-300',
        inactiveDayBg: 'bg-slate-700',
        gridBg: 'bg-blue-100',
        divider: 'divide-gray-300',
        todayBg: 'bg-yellow-200',
        buttonHover: 'hover:text-gray-800',
        eventBg: 'bg-blue-100',
        eventHeaderBg: 'bg-blue-200',
        eventBorder: 'border-blue-300',
        eventText: 'text-gray-900',
        modalBg: 'bg-white',
        modalOverlay: 'bg-black bg-opacity-50',
        link: 'text-blue-600 hover:text-blue-800',
        border: 'border-gray-200',
        tag: 'bg-blue-100 text-blue-800',
        loadingBg: 'bg-white',
        loadingText: 'text-gray-900',
        alertBackground: 'bg-red-200',
        weekendHeaderBg: 'bg-slate-700',
        weekdayHeaderBg: 'bg-slate-600',
        dayNameText: 'text-slate-100',
        eventCountBg: 'bg-blue-300',
        button: 'bg-gray-400 !text-white',
        todayBackground: 'bg-gray-600 text-white',
        featuredDay: 'bg-yellow-100 italic',
        todayBarBackground: 'bg-gray-200',
        // Detail pane
        detailPaneBg: 'bg-slate-100',
        panelBorder: 'border-slate-300',
        // List view
        cardBg: 'bg-gray-50',
        actionButton: 'bg-blue-500 hover:bg-blue-600 text-white',
        expandButton: 'bg-blue-100 hover:bg-blue-200 text-blue-700',
        // Filter buttons
        favoritesActive: 'bg-red-100 text-red-700 border-red-300',
        hidePrivateActive: 'bg-blue-100 text-blue-700 border-blue-300',
        filterInactive: 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200',
        // Nav chrome
        viewButtonActive: 'bg-blue-500 text-white',
        viewButtonInactive: 'bg-gray-200 hover:bg-gray-300 text-gray-700',
        navLink: 'text-gray-600 hover:text-gray-800',
        pickerBg: 'bg-white border-gray-200',
        pickerHover: 'hover:bg-blue-100',
        navArrowHover: 'hover:bg-gray-100',
    },
    dark: {
        background: 'bg-gray-900',
        text: 'text-gray-100',
        secondaryText: 'text-gray-300',
        headerBg: 'bg-gray-800',
        headerText: 'text-gray-100',
        dayBg: 'bg-gray-800',
        dayHeaderBg: 'bg-gray-700',
        inactiveDayBg: 'bg-gray-900',
        gridBg: 'bg-gray-700',
        divider: 'divide-gray-900',
        todayBg: 'bg-yellow-300/30',
        buttonHover: 'hover:text-white',
        eventBg: 'bg-blue-900',
        eventHeaderBg: 'bg-blue-800',
        eventBorder: 'border-blue-600',
        eventText: 'text-gray-100',
        modalBg: 'bg-gray-800',
        modalOverlay: 'bg-black bg-opacity-70',
        link: 'text-slate-400 hover:text-slate-300',
        border: 'border-gray-700',
        tag: 'bg-slate-900 text-slate-200',
        loadingBg: 'bg-gray-800',
        loadingText: 'text-gray-100',
        alertBackground: 'bg-yellow-900',
        weekendHeaderBg: 'bg-slate-900',
        weekdayHeaderBg: 'bg-slate-600',
        dayNameText: 'text-slate-100',
        eventCountBg: 'bg-blue-900',
        button: 'bg-gray-400 !text-white',
        todayBackground: 'bg-gray-300 text-black',
        featuredDay: 'bg-yellow-900/40 italic',
        todayBarBackground: 'bg-gray-700',
        // Detail pane
        detailPaneBg: 'bg-slate-800',
        panelBorder: 'border-slate-600',
        // List view
        cardBg: 'bg-gray-800',
        actionButton: 'bg-blue-700 hover:bg-blue-600 text-white',
        expandButton: 'bg-slate-700 hover:bg-slate-600 text-slate-200',
        // Filter buttons
        favoritesActive: 'bg-red-900/40 text-red-300 border-red-700',
        hidePrivateActive: 'bg-blue-900/40 text-blue-300 border-blue-700',
        filterInactive: 'bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600',
        // Nav chrome
        viewButtonActive: 'bg-blue-700 text-white',
        viewButtonInactive: 'bg-gray-700 hover:bg-gray-600 text-gray-200',
        navLink: 'text-gray-300 hover:text-white',
        pickerBg: 'bg-gray-800 border-gray-700',
        pickerHover: 'hover:bg-gray-700',
        navArrowHover: 'hover:bg-gray-700',
    }
};
